export default __webpack_public_path__ + "static/customer-service-management_attribution_light-933bff93fb2da286ecccefa1f20c28f7.svg";